module.exports = "/fonts/vendor/mavon-editor/dist/fontello.ttf?2fc515b17bf02cae65c3687efecc38c9";